module.exports = __webpack_public_path__ + "static/img/av1.51870334.png";